export default __webpack_public_path__ + "static/media/Granja Morais.c7bd300e.png";